"use client";

export { default } from "../../src/app/goals/error";
